import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/image/customer-phone.png'
import _imports_1 from '../../assets/image/customer-verify.png'
import _imports_2 from '../../assets/image/recheck-result.png'
import _imports_3 from '../../assets/image/material.png'
import _imports_4 from '../../assets/image/ensure-end.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-ed803e04")

_pushScopeId("data-v-ed803e04")
const _hoisted_1 = { class: "ensure-service-explain" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("保障服务说明 ")
const _hoisted_4 = { class: "ensure-service-explain-content" }
const _hoisted_5 = { class: "ensure-standard ensure-section" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "ensure-title" }, "保障范围", -1)
const _hoisted_7 = { class: "ensure-text" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, "1.被检车辆在检测基准日完成车辆检测前，经举证并复核属于重大事故车、火烧车或泡水车，即事故排查检测认定错误；或经举证并复核车辆发动机主体、变速箱主体的检测损伤与实车不符。", -1)
const _hoisted_9 = { class: "ensure-time ensure-section" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "ensure-title" }, "保障时间", -1)
const _hoisted_11 = { class: "ensure-text" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "ensure-flow ensure-section" }, [
  /*#__PURE__*/_createVNode("div", { class: "ensure-title" }, "承保流程"),
  /*#__PURE__*/_createVNode("div", { class: "ensure-flex" }, [
    /*#__PURE__*/_createVNode("div", { class: "ensure-flex-item" }, [
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-img" }, [
        /*#__PURE__*/_createVNode("img", {
          src: _imports_0,
          alt: ""
        }),
        /*#__PURE__*/_createVNode("i")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-text" }, [
        /*#__PURE__*/_createTextVNode(" 拨打客服电话"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createTextVNode("400-808-3718 ")
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "ensure-flex-item" }, [
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-img" }, [
        /*#__PURE__*/_createVNode("img", {
          src: _imports_1,
          alt: ""
        }),
        /*#__PURE__*/_createVNode("i")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-text" }, [
        /*#__PURE__*/_createTextVNode(" 客服核实"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createTextVNode("情况 ")
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "ensure-flex-item" }, [
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-img" }, [
        /*#__PURE__*/_createVNode("img", {
          src: _imports_2,
          alt: ""
        }),
        /*#__PURE__*/_createVNode("i")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-text" }, [
        /*#__PURE__*/_createTextVNode(" 车辆复检并提"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createTextVNode("供复检结论 ")
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "ensure-flex-item" }, [
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-img" }, [
        /*#__PURE__*/_createVNode("img", {
          src: _imports_3,
          alt: ""
        }),
        /*#__PURE__*/_createVNode("i")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-text" }, [
        /*#__PURE__*/_createTextVNode(" 提供所需"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createTextVNode("材料 ")
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "ensure-flex-item" }, [
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-img" }, [
        /*#__PURE__*/_createVNode("img", {
          src: _imports_4,
          alt: ""
        })
      ]),
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-text" }, " 承保结束 ")
    ])
  ])
], -1)
const _hoisted_13 = { class: "ensure-person ensure-section" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "ensure-title" }, "承保受益人", -1)
const _hoisted_15 = { class: "ensure-text" }
const _hoisted_16 = { class: "ensure-duty ensure-section" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "ensure-title" }, "承保责任", -1)
const _hoisted_18 = { class: "ensure-text" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", null, "处置价格指：被检车辆被判定为事故判定错误后以拍卖方式处置的价格。", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("p", null, "2.交易价格合理性评估：我们有权参照同地区、同款车型、同年份、同车况的二手车销售价对交易价格合理性进行评估，如交易价格超出市场合理价15%的，我们仅能以市场合理价为上限进行赔付，超出部分不赔付。", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("p", null, "3.自检测报告出具后，车辆出现新增明显损伤的，车辆赔付金额应扣除损伤维修费和新增损伤带来的二次销售车价折损。", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("p", null, "4.对268V的复检结论、收购价格等存在异议的，应当自行委托其他具备二手车评估鉴定资质的第三方机构按照GB∕T 30323-2013《二手车鉴定评估技术规范》国家标准规定的程序出具鉴定评估报告，并及时提交给我们。经我们或者生效法律文书确认我们的复检结论有误的，我们将承担鉴定评估费用，但最多不超过1500元；经我们或者生效法律文书确认我们的复检结论无误的，该鉴定评估费用由您负担。", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "ensure-person-duty ensure-section" }, [
  /*#__PURE__*/_createVNode("div", { class: "ensure-title" }, "承保受益人如何索赔"),
  /*#__PURE__*/_createVNode("div", { class: "ensure-text" }, [
    /*#__PURE__*/_createVNode("p", null, "1.268V有权自行或委派第三方对被检车辆进行复查、勘验或检查，承保受益人有义务予以配合。"),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createTextVNode("2.向268V提出保障范围内的赔付请求时，经我们复检确认检测报告认证错误，承保受益人需在收到通知之日起（含当日）7个自然日内提交下述所有资料原件及复印件，否则视为放弃理赔："),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" （1）车辆买方的身份证或企业营业执照；"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" （2）书面索赔申请原件；"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" （3）被检车辆二手交易买卖合同、打款凭证、车辆行驶证、机动车登记证、车辆过户发票；"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" （4）268V的检测报告、268V出具的268V检测认证承诺书（线上）；"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" （5）能够举证证明268V的检测存在错误的证明文件；"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" （6）其他268V认为必要且合理的文件。")
    ])
  ])
], -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "ensure-person-claim ensure-section" }, [
  /*#__PURE__*/_createVNode("div", { class: "ensure-title" }, "双方权利义务"),
  /*#__PURE__*/_createVNode("div", { class: "ensure-text" }, [
    /*#__PURE__*/_createVNode("p", null, "1.检测师按照与您约定的时间到达指定位置，如因您的原因导致我们无法检测指定车辆，我们的检测师等待15分钟后可以取消订单。我们可以直接从您已支付的全部检测费用中扣除您已付费用的75%以及全部交通费用作为违约金，剩余部分退还至您的账户。"),
    /*#__PURE__*/_createVNode("p", null, "2.我们至迟在检测完成后48小时内出具检测报告，您应当在收到检测报告后再进行交易或其他决策。您未认真阅读检测报告而导致的损失，我们不承担相关责任。"),
    /*#__PURE__*/_createVNode("p", null, "3.被检车辆需要进行举升或拆解，因现场条件受限等各类原因导致我们未能进行进一步检查的，应当在检测报告中予以提示。您可到我们的检测中心（或合作方网点）要求我们提供免费复检服务。我们对未检测情况已经予以提示的，就该部分不承担相关责任。")
  ])
], -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "ensure-relief ensure-section" }, [
  /*#__PURE__*/_createVNode("div", { class: "ensure-title" }, "免责"),
  /*#__PURE__*/_createVNode("div", { class: "ensure-text" }, [
    /*#__PURE__*/_createVNode("p", null, "具备下列情形之一的，268V免责："),
    /*#__PURE__*/_createVNode("p", null, "1.检测报告出具后，车辆在报告激活期限内未转移登记或在报告激活期限内未激活的，报告及对应承诺失效；"),
    /*#__PURE__*/_createVNode("p", null, "2.检测报告出具后，不论是否激活，车辆转移登记次数超过2次的，报告及对应承诺失效；"),
    /*#__PURE__*/_createVNode("p", null, "3.承保激活后车辆再次转移登记的，承保失效，激活受益人及再次购买人均无权理赔。"),
    /*#__PURE__*/_createVNode("p", null, "4.承保受益人提出异议的时间超过承保期间；"),
    /*#__PURE__*/_createVNode("p", null, "5.承保受益人未在我们通知提交理赔材料的7个自然日内提供合法、有效的各类必要证明材料及索赔材料的；"),
    /*#__PURE__*/_createVNode("p", null, "6.受限不可检：车主或委托人已签署《受限不可检同意书》或已经在检测报告中或补充说明中已予以提示的，则相关部件的真实情况不在我们车辆检测保障承诺范围内。"),
    /*#__PURE__*/_createVNode("p", null, "7.承保受益人因各类原因未能配合我们复检或者配合我们委派的第三方对车辆进行勘察的；"),
    /*#__PURE__*/_createVNode("p", null, "8.检测当日车辆的真实状况不足以反映车辆曾发生过重大事故、火烧、泡水问题的。"),
    /*#__PURE__*/_createVNode("p", null, "9.我们出具车辆检测报告后因任何原因导致车况状态发生变化，并因此导致检测结果不再适用的；"),
    /*#__PURE__*/_createVNode("p", null, "10.因不可归责于我们的原因造成被检车辆损失扩大的，我们就扩大部分损失免责；"),
    /*#__PURE__*/_createVNode("p", null, "11.被检车辆存在违反《中华人民共和国道路交通安全法》第十六条所规定情形的，我们免责，并可以将违法线索移送公安机关依法处理。上述情形包括：拼装机动车或者擅自改变机动车已登记的结构、构造或者特征；改变机动车型号、发动机号、车架号或者车辆识别代号；伪造、变造或者使用伪造、变造的机动车登记证书、号牌、行驶证、检验合格标志、保险标志；使用其他机动车的登记证书、号牌、行驶证、检验合格标志、保险标志。"),
    /*#__PURE__*/_createVNode("p", null, "12.承保受益人拒绝协助我们及相关保险公司对车辆进行勘验或检查的")
  ])
], -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode("保障服务说明 ")
const _hoisted_28 = { class: "ensure-service-explain-content" }
const _hoisted_29 = { class: "ensure-standard ensure-section" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "ensure-title" }, "保障范围", -1)
const _hoisted_31 = {
  key: 0,
  class: "ensure-text"
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode("【买车无忧检】")
const _hoisted_33 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 1.被检车辆在检测基准日完成车辆检测前，经举证并复核属于重大事故车、火烧车或泡水车，即事故排查检测认定错误。")
const _hoisted_35 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("【买车无忧保】"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 双认证表示车辆通过了268V车况检测认证及质保检测合格认证，车况符合准入条件并享有购买“最低一年3万公里”质保产品的资格（精选保障plus产品可享一年不限公里保修），如未购买该产品则不享有相应的保修服务保障，具体保修范围、最高赔付限额、保修期限（年限及公里数限制）等以实际购买产品为准。 ")
], -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("购买流程："),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" ① 经过双认证或质保检测合格"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("② 选择对应产品付费购买"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("③ 提供所需材料"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("④ 保修服务生效 ")
], -1)
const _hoisted_38 = {
  key: 1,
  class: "ensure-text"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("p", null, "1.被检车辆在检测基准日完成车辆检测前，经举证并复核属于重大事故车、火烧车或泡水车，即事故排查检测认定错误。", -1)
const _hoisted_40 = {
  key: 2,
  class: "ensure-text"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("p", null, "1.被检车辆在检测基准日完成车辆检测前，经举证并复核属于重大事故车、火烧车或泡水车，即事故排查检测认定错误。", -1)
const _hoisted_42 = { class: "ensure-time ensure-section" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "ensure-title" }, "保障时间", -1)
const _hoisted_44 = {
  key: 0,
  class: "ensure-text"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_46 = {
  key: 1,
  class: "ensure-text"
}
const _hoisted_47 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "ensure-flow ensure-section" }, [
  /*#__PURE__*/_createVNode("div", { class: "ensure-title" }, "承保流程"),
  /*#__PURE__*/_createVNode("div", { class: "ensure-flex" }, [
    /*#__PURE__*/_createVNode("div", { class: "ensure-flex-item" }, [
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-img" }, [
        /*#__PURE__*/_createVNode("img", {
          src: _imports_0,
          alt: ""
        }),
        /*#__PURE__*/_createVNode("i")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-text" }, [
        /*#__PURE__*/_createTextVNode(" 拨打客服电话"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createTextVNode("400-808-3718 ")
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "ensure-flex-item" }, [
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-img" }, [
        /*#__PURE__*/_createVNode("img", {
          src: _imports_1,
          alt: ""
        }),
        /*#__PURE__*/_createVNode("i")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-text" }, [
        /*#__PURE__*/_createTextVNode(" 客服核实"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createTextVNode("情况 ")
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "ensure-flex-item" }, [
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-img" }, [
        /*#__PURE__*/_createVNode("img", {
          src: _imports_2,
          alt: ""
        }),
        /*#__PURE__*/_createVNode("i")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-text" }, [
        /*#__PURE__*/_createTextVNode(" 车辆复检并提"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createTextVNode("供复检结论 ")
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "ensure-flex-item" }, [
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-img" }, [
        /*#__PURE__*/_createVNode("img", {
          src: _imports_3,
          alt: ""
        }),
        /*#__PURE__*/_createVNode("i")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-text" }, [
        /*#__PURE__*/_createTextVNode(" 提供所需"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createTextVNode("材料 ")
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "ensure-flex-item" }, [
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-img" }, [
        /*#__PURE__*/_createVNode("img", {
          src: _imports_4,
          alt: ""
        })
      ]),
      /*#__PURE__*/_createVNode("div", { class: "ensure-icon-text" }, " 承保结束 ")
    ])
  ])
], -1)
const _hoisted_49 = { class: "ensure-person ensure-section" }
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { class: "ensure-title" }, "承保受益人", -1)
const _hoisted_51 = { class: "ensure-text" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "ensure-duty ensure-section" }
const _hoisted_55 = /*#__PURE__*/_createVNode("div", { class: "ensure-title" }, "承保责任", -1)
const _hoisted_56 = {
  key: 0,
  class: "ensure-text"
}
const _hoisted_57 = /*#__PURE__*/_createVNode("p", null, "处置价格指：被检车辆被判定为事故判定错误后进行拍卖或以其他方式处置的价格。", -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("p", null, "2.自检测报告出具后，车辆出现新增明显损伤的，车辆赔付金额应扣除损伤维修费和新增损伤带来的二次销售车价折损。", -1)
const _hoisted_59 = /*#__PURE__*/_createVNode("p", null, "3.对268V的复检结论存在异议的，应当自行委托其他具备二手车评估鉴定资质的第三方机构按照GB∕T 30323-2013《二手车鉴定评估技术规范》国家标准规定的程序出具鉴定评估报告，并及时提交给我们。经我们或者生效法律文书确认我们的复检结论有误的，我们将承担鉴定评估费用，但最多不超过1500元；经我们或者生效法律文书确认我们的复检结论无误的，该鉴定评估费用由您负担。", -1)
const _hoisted_60 = {
  key: 1,
  class: "ensure-text"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("p", null, "处置价格指：被检车辆被判定为事故判定错误后以拍卖方式处置的价格。", -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("p", null, "2.交易价格合理性评估：我们有权参照同地区、同款车型、同年份、同车况的二手车销售价对交易价格合理性进行评估，如交易价格超出市场合理价15%的，我们仅能以市场合理价为上限进行赔付，超出部分不赔付。", -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("p", null, "3.自检测报告出具后，车辆出现新增明显损伤的，车辆赔付金额应扣除损伤维修费和新增损伤带来的二次销售车价折损。", -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("p", null, "4.对268V的复检结论、收购价格等存在异议的，应当自行委托其他具备二手车评估鉴定资质的第三方机构按照GB∕T 30323-2013《二手车鉴定评估技术规范》国家标准规定的程序出具鉴定评估报告，并及时提交给我们。经我们或者生效法律文书确认我们的复检结论有误的，我们将承担鉴定评估费用，但最多不超过1500元；经我们或者生效法律文书确认我们的复检结论无误的，该鉴定评估费用由您负担。", -1)
const _hoisted_65 = { class: "ensure-person-duty ensure-section" }
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { class: "ensure-title" }, "承保受益人如何索赔", -1)
const _hoisted_67 = { class: "ensure-text" }
const _hoisted_68 = /*#__PURE__*/_createVNode("p", null, "1.268V有权自行或委派第三方对被检车辆进行复查、勘验或检查，承保受益人有义务予以配合。", -1)
const _hoisted_69 = /*#__PURE__*/_createTextVNode("2.向268V提出保障范围内的赔付请求时，经我们复检确认检测报告认证错误，承保受益人需在收到通知之日起（含当日）7个自然日内提交下述所有资料原件及复印件，否则视为放弃理赔：")
const _hoisted_70 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" （2）书面索赔申请原件；")
const _hoisted_73 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" （3）被检车辆二手交易买卖合同、打款凭证、车辆行驶证、机动车登记证、车辆过户发票；")
const _hoisted_75 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" （4）268V的检测报告、268V出具的268V检测认证承诺书（线上）；")
const _hoisted_77 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" （5）能够举证证明268V的检测存在错误的证明文件；")
const _hoisted_79 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" （6）其他268V认为必要且合理的文件。")
const _hoisted_81 = { class: "ensure-person-claim ensure-section" }
const _hoisted_82 = /*#__PURE__*/_createVNode("div", { class: "ensure-title" }, "双方权利义务", -1)
const _hoisted_83 = { class: "ensure-text" }
const _hoisted_84 = /*#__PURE__*/_createVNode("p", null, "1.检测师按照与您约定的时间到达指定位置，如因您的原因导致我们无法检测指定车辆，我们的检测师等待15分钟后可以取消订单。我们可以直接从您已支付的全部检测费用中扣除您已付费用的75%以及全部交通费用作为违约金，剩余部分退还至您的账户。", -1)
const _hoisted_85 = /*#__PURE__*/_createVNode("p", null, "2.我们至迟在检测完成后48小时内出具检测报告，您应当在收到检测报告后再进行交易或其他决策。您未认真阅读检测报告而导致的损失，我们不承担相关责任。", -1)
const _hoisted_86 = { key: 0 }
const _hoisted_87 = { class: "ensure-relief ensure-section" }
const _hoisted_88 = /*#__PURE__*/_createVNode("div", { class: "ensure-title" }, "免责", -1)
const _hoisted_89 = {
  key: 0,
  class: "ensure-text"
}
const _hoisted_90 = /*#__PURE__*/_createStaticVNode("<p data-v-ed803e04>1.承保受益人提出异议的时间超过承保期间；</p><p data-v-ed803e04>2.承保受益人未在我们通知提交理赔材料的7个自然日内提供合法、有效的各类必要证明材料及索赔材料的；</p><p data-v-ed803e04>3.承保车辆在首次交易后再次被交易的，承保终止，首次交易的第一买受人及再次购买人均无权激活或发起理赔。</p><p data-v-ed803e04>4.受限不可检：车主或委托人已签署《受限不可检同意书》或已经在检测报告中或补充说明中已予以提示的，则相关部件的真实情况不在我们车辆检测保障承诺范围内。</p><p data-v-ed803e04>5.承保受益人因各类原因未能配合268V复检或者配合268V委派的第三方对车辆进行勘察的；</p><p data-v-ed803e04>6.检测当日车辆的真实状况不足以反映车辆曾发生过重大事故、火烧、泡水问题的；</p><p data-v-ed803e04>7.268V出具车辆检测报告后因任何原因导致车况状态发生变化，并因此导致检测结果不再适用的；</p><p data-v-ed803e04>8.因不可归责于268V的原因造成被检车辆损失扩大的，268V就扩大部分损失免责；</p><p data-v-ed803e04>9.被检车辆存在违反《中华人民共和国道路交通安全法》第十六条所规定情形的，268V免责，并可以将违法线索移送公安机关依法处理。上述情形包括：拼装机动车或者擅自改变机动车已登记的结构、构造或者特征；改变机动车型号、发动机号、车架号或者车辆识别代号；伪造、变造或者使用伪造、变造的机动车登记证书、号牌、行驶证、检验合格标志、保险标志；使用其他机动车的登记证书、号牌、行驶证、检验合格标志、保险标志。</p><p data-v-ed803e04>10.承保受益人拒绝协助268V及相关保险公司对车辆进行勘验或检查的。</p>", 10)
const _hoisted_100 = {
  key: 1,
  class: "ensure-text"
}
const _hoisted_101 = /*#__PURE__*/_createStaticVNode("<p data-v-ed803e04>具备下列情形之一的，268V免责：</p><p data-v-ed803e04>1.检测报告出具后，车辆在报告激活期限内未转移登记或在报告激活期限内未激活的，报告及对应承诺失效；</p><p data-v-ed803e04>2.检测报告出具后，不论是否激活，车辆转移登记次数超过2次的，报告及对应承诺失效；</p><p data-v-ed803e04>3.承保激活后车辆再次转移登记的，承保失效，激活受益人及再次购买人均无权理赔。</p><p data-v-ed803e04>4.承保受益人提出异议的时间超过承保期间；</p><p data-v-ed803e04>5.承保受益人未在我们通知提交理赔材料的7个自然日内提供合法、有效的各类必要证明材料及索赔材料的；</p><p data-v-ed803e04>6.受限不可检：车主或委托人已签署《受限不可检同意书》或已经在检测报告中或补充说明中已予以提示的，则相关部件的真实情况不在我们车辆检测保障承诺范围内。</p><p data-v-ed803e04>7.承保受益人因各类原因未能配合我们复检或者配合我们委派的第三方对车辆进行勘察的；</p><p data-v-ed803e04>8.检测当日车辆的真实状况不足以反映车辆曾发生过重大事故、火烧、泡水问题的。</p><p data-v-ed803e04>9.我们出具车辆检测报告后因任何原因导致车况状态发生变化，并因此导致检测结果不再适用的；</p><p data-v-ed803e04>10.因不可归责于我们的原因造成被检车辆损失扩大的，我们就扩大部分损失免责；</p><p data-v-ed803e04>11.被检车辆存在违反《中华人民共和国道路交通安全法》第十六条所规定情形的，我们免责，并可以将违法线索移送公安机关依法处理。上述情形包括：拼装机动车或者擅自改变机动车已登记的结构、构造或者特征；改变机动车型号、发动机号、车架号或者车辆识别代号；伪造、变造或者使用伪造、变造的机动车登记证书、号牌、行驶证、检验合格标志、保险标志；使用其他机动车的登记证书、号牌、行驶证、检验合格标志、保险标志。</p><p data-v-ed803e04>12.承保受益人拒绝协助我们及相关保险公司对车辆进行勘验或检查的</p>", 13)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.state.reportLevel === 2)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", {
            class: "ensure-service-explain-header",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, [
            _hoisted_2,
            _hoisted_3
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode("p", null, "2.承保期限最长为承保激活日起" + _toDisplayString(_ctx.state.protectTime) + "日（含当日）；承保激活后车辆再次转移登记则承保失效。", 1)
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode("div", _hoisted_11, [
                _createVNode("p", null, "事故排查检测认定错误的保障期间是承保激活日起" + _toDisplayString(_ctx.state.protectTime) + "日（含当日）。动力系统检测错误的保障期间是承保激活次日起" + _toDisplayString(_ctx.state.protectTime) + "日（含当日）且新增公里数不超过5000公里；增强版保障期间是承保激活次日起365日（含当日）且新增公里数不超过10000公里。", 1),
                _createVNode("p", null, "请在车辆完成交易及过户后，微信搜索【268V车况检测专家】小程序，进入保障激活页面，填写成交信息及上传交易凭证，激活" + _toDisplayString(_ctx.state.protectTime) + "天收购保障后，我们将向您发送《268V检测认证承诺书》。", 1)
              ])
            ]),
            _hoisted_12,
            _createVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode("div", _hoisted_15, [
                _createVNode("p", null, "检测报告出具日起（含当日）" + _toDisplayString(_ctx.state.protectTime) + "日内，被检车辆的当前所有人（以转移登记为准），且需同时符合以下所有条件：1）检测报告出具后被检车辆转移次数为1次或2次，2）当前所有人已支付合理对价，完成了车辆过户，3）在报告激活期限内完成了承保激活。您应当向我们提交承保受益人信息并接受我们的核验。", 1)
              ])
            ]),
            _createVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode("div", _hoisted_18, [
                _createVNode("p", null, "1.经268V检测认定车辆不存在重大事故、火烧、泡水车的，我们将在出具检测报告外向您在检测报告出具 日起（含当日）" + _toDisplayString(_ctx.state.protectTime) + "日内提交的承保受益人发送《268V检测认证承诺书》，如承保激活日起" + _toDisplayString(_ctx.state.protectTime) + "日（含当日）内发现被检车辆系检测报告出具前的重大事故车、火烧车、泡水车而我们出具的检测报告未显示该情况的，经复检确认后，268V或268V的指定方按照交易价格购买该车辆，或者就承保受益人购车的交易价格和处置价格的差价进行差额补偿。 发动机主体、变速箱主体检测错误的，268V或268V的指定方对车辆进行限额维修，变速箱和发动机主体两者累计总保障金额普通版不超过5000元，增强版不超过10000元。", 1),
                _createVNode("p", null, "交易价格指：被检车辆在检测报告出具后" + _toDisplayString(_ctx.state.protectTime) + "天内，承保受益人购买被检车辆的成交价格；", 1),
                _hoisted_19,
                _hoisted_20,
                _hoisted_21,
                _hoisted_22
              ])
            ]),
            _hoisted_23,
            _hoisted_24,
            _hoisted_25
          ])
        ], 64))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode("div", {
            class: "ensure-service-explain-header",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, [
            _hoisted_26,
            _hoisted_27
          ]),
          _createVNode("div", _hoisted_28, [
            _createVNode("div", _hoisted_29, [
              _hoisted_30,
              (_ctx.state.reportLevel === 32)
                ? (_openBlock(), _createBlock("div", _hoisted_31, [
                    _createVNode("p", null, [
                      _hoisted_32,
                      _hoisted_33,
                      _hoisted_34,
                      _hoisted_35,
                      _createTextVNode(" 2.承保期限最长为承保激活日起" + _toDisplayString(_ctx.state.protectTime) + "日（含当日）；承保激活后车辆再次转移登记则承保失效。", 1)
                    ]),
                    _hoisted_36,
                    _hoisted_37
                  ]))
                : (_ctx.state.reportLevel === 8 || _ctx.state.reportLevel === 4)
                  ? (_openBlock(), _createBlock("div", _hoisted_38, [
                      _hoisted_39,
                      _createVNode("p", null, "2.仅限于保障检测完成后被检车辆的首次买卖交易差额风险；承保期限最长为检测完成后首次过户完成之日起（含当日）" + _toDisplayString(_ctx.state.protectTime) + "日。", 1)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_40, [
                      _hoisted_41,
                      _createVNode("p", null, "2.承保期限最长为承保激活日起" + _toDisplayString(_ctx.state.protectTime) + "日（含当日）；承保激活后车辆再次转移登记则承保失效。", 1)
                    ]))
            ]),
            _createVNode("div", _hoisted_42, [
              _hoisted_43,
              (_ctx.state.reportLevel === 8 || _ctx.state.reportLevel === 4)
                ? (_openBlock(), _createBlock("div", _hoisted_44, [
                    _createTextVNode(" 保障期间是检测完成后首次交易过户之日起" + _toDisplayString(_ctx.state.protectTime) + "日（含当日）。 获取保障的前提需要激活，检测报告出具日起（含当日）" + _toDisplayString(_ctx.state.protectTime) + "日内您在我们的系统内录入承保受益人信息进行激活， 过期失效。", 1),
                    _hoisted_45,
                    _createTextVNode(" 请在车辆完成交易及过户后，微信搜索【268V车况检测专家】小程序，进入保障激活页面，填写成交信息及上传交易凭证，激活" + _toDisplayString(_ctx.state.protectTime) + "天收购保障后， 我们将向您发送《268V检测认证承诺书》。 ", 1)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_46, [
                    _createTextVNode(" 保障期间是承保激活日起" + _toDisplayString(_ctx.state.protectTime) + "日（含当日）。 获取保障的前提需要激活，检测报告出具日起（含当日）" + _toDisplayString(_ctx.state.protectTime) + "日内您在我们的系统内录入承保受益人信息进行激活， 过期失效。", 1),
                    _hoisted_47,
                    _createTextVNode(" 请在车辆完成交易及过户后，微信搜索【268V车况检测专家】小程序，进入保障激活页面，填写成交信息及上传交易凭证，激活" + _toDisplayString(_ctx.state.protectTime) + "天收购保障后， 我们将向您发送《268V检测认证承诺书》。 ", 1)
                  ]))
            ]),
            _hoisted_48,
            _createVNode("div", _hoisted_49, [
              _hoisted_50,
              _createVNode("div", _hoisted_51, [
                (_ctx.state.reportLevel === 8 || _ctx.state.reportLevel === 4)
                  ? (_openBlock(), _createBlock("p", _hoisted_52, "检测报告出具日起（含当日）" + _toDisplayString(_ctx.state.protectTime) + "日内，被检车辆（以被检车辆VIN码为准）被首次交易的第一买受人，且该买受人应已支付合理对价，完成了车辆过户，并在规定时间内完整提交本合同所规定的代为售出或者差额补偿相关文件。若您不符合承保受益人条件，我们有权取消本承诺。", 1))
                  : (_openBlock(), _createBlock("p", _hoisted_53, "检测报告出具日起（含当日）" + _toDisplayString(_ctx.state.protectTime) + "日内，被检车辆的当前所有人（以转移登记为准），且需同时符合以下所有条件：1）检测报告出具后被检车辆转移次数为1次或2次，2）当前所有人已支付合理对价，完成了车辆过户，3）在报告激活期限内完成了承保激活。您应当向我们提交承保受益人信息并接受我们的核验。", 1))
              ])
            ]),
            _createVNode("div", _hoisted_54, [
              _hoisted_55,
              (_ctx.state.reportLevel === 4)
                ? (_openBlock(), _createBlock("div", _hoisted_56, [
                    _createVNode("p", null, "1.经268V检测认定车辆不存在重大事故、火烧、泡水车的，我们将在出具检测报告外向您在检测报告出具日起（含当日）" + _toDisplayString(_ctx.state.protectTime) + "日内提交的承保受益人发送《268V检测认证承诺书》，如268V完成检测后首次交易过户完成之日起（含当日）" + _toDisplayString(_ctx.state.protectTime) + "日内被检车辆被发现检测认证错误（即未准确反映重大事故车、火烧车或泡水车情况的），经复检确认后，268V或268V的指定方按照交易价格购买该车辆，或者就承保受益人购车的交易价格和处置价格的差价进行差额补偿。", 1),
                    _createVNode("p", null, "交易价格指：被检车辆在检测报告出具后" + _toDisplayString(_ctx.state.protectTime) + "天内第一次交易的车辆成交价格；", 1),
                    _hoisted_57,
                    _hoisted_58,
                    _hoisted_59
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_60, [
                    _createVNode("p", null, "1.经268V检测认定车辆不存在重大事故、火烧、泡水车的，我们将在出具检测报告外向您在检测报告出具 日起（含当日）" + _toDisplayString(_ctx.state.protectTime) + "日内提交的承保受益人发送《268V检测认证承诺书》，如承保激活日起" + _toDisplayString(_ctx.state.protectTime) + "日（含当日）内发现被检车辆系检测报告出具前的重大事故车、火烧车、泡水车而我们出具的检测报告未显示该情况的，经复检确认后，268V或268V的指定方按照交易价格购买该车辆，或者就承保受益人购车的交易价格和处置价格的差价进行差额补偿。", 1),
                    _createVNode("p", null, "交易价格指：被检车辆在检测报告出具后" + _toDisplayString(_ctx.state.protectTime) + "天内，承保受益人购买被检车辆的成交价格；", 1),
                    _hoisted_61,
                    _hoisted_62,
                    _hoisted_63,
                    _hoisted_64
                  ]))
            ]),
            _createVNode("div", _hoisted_65, [
              _hoisted_66,
              _createVNode("div", _hoisted_67, [
                _hoisted_68,
                _createVNode("p", null, [
                  _hoisted_69,
                  _hoisted_70,
                  _createTextVNode(" （1）车辆买方的身份证" + _toDisplayString(_ctx.state.reportLevel === 4 ? '' : '或企业营业执照') + "；", 1),
                  _hoisted_71,
                  _hoisted_72,
                  _hoisted_73,
                  _hoisted_74,
                  _hoisted_75,
                  _hoisted_76,
                  _hoisted_77,
                  _hoisted_78,
                  _hoisted_79,
                  _hoisted_80
                ])
              ])
            ]),
            _createVNode("div", _hoisted_81, [
              _hoisted_82,
              _createVNode("div", _hoisted_83, [
                _hoisted_84,
                _hoisted_85,
                (_ctx.state.reportLevel !== 8)
                  ? (_openBlock(), _createBlock("p", _hoisted_86, "3.被检车辆需要进行举升或拆解，因现场条件受限等各类原因导致我们未能进行进一步检查的，应当在检测报告中予以提示。您可到我们的检测中心（或合作方网点）要求我们提供免费复检服务。我们对未检测情况已经予以提示的，就该部分不承担相关责任。"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_87, [
              _hoisted_88,
              (_ctx.state.reportLevel === 8 || _ctx.state.reportLevel === 4)
                ? (_openBlock(), _createBlock("div", _hoisted_89, [
                    _hoisted_90
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_100, [
                    _hoisted_101
                  ]))
            ])
          ])
        ], 64))
  ]))
})